import { Heading } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseLayout } from '..'
import { colors } from '../../../ui-kit'
import UpcomingInvoiceTable from '../../components/Billing/UpcomingInvoiceTable'
import { MainContentHeadingBox, MainContentWrapper } from '../Base/MainContent'

const InvoicesLayout = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <BaseLayout>
      <MainContentHeadingBox>
        <Heading
          as="h5"
          size="md"
          fontWeight="600"
          color={colors.appDarkIndigo}
        >
          {t('upcoming_invoice', 'Upcoming invoice')}
        </Heading>
      </MainContentHeadingBox>
      <MainContentWrapper style={{ gap: '0.5em' }}>
        <UpcomingInvoiceTable />
      </MainContentWrapper>
    </BaseLayout>
  )
}

export default InvoicesLayout
